
import { Suspense } from "react";
import type { CourseContent } from "@/services/vitrin-service";
import ContentView from "@/features/content/components/content-view";

type Props = {
  contents: CourseContent[];
  lessonTitle?: string;
  analyticsContext?: {
    miniappId?: string;
    courseId?: number;
    lessonId?: number;
  };
};

export default function LessonContents({ contents, lessonTitle, analyticsContext }: Props) {
  if (!contents.length) {
    return (
      <div className="py-6 text-center text-sm text-default-400">
        محتوایی یافت نشد.
      </div>
    );
  }

  return (
    <div dir="rtl" className="content-font space-y-6 px-4 pb-8">
      {contents.map((content) => (
        <Suspense
          key={content.id}
          fallback={<div className="h-3 animate-pulse rounded bg-content3" />}
        >
          <ContentView
            content={content}
            lessonTitle={lessonTitle}
            analyticsContext={analyticsContext}
          />
        </Suspense>
      ))}
    </div>
  );
}
